<template>
  <div id="content"
       class="flex">
    <div class="page-content page-container"
         id="page-content">
      <div class="padding">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header"><strong>Reset Password</strong></div>
              <div class="card-body">
                <Form :validation-schema="schema">
                  <div class="form-group">
                    <label for="email-for-pass">Enter your new password</label>
                    <Field type="password"
                           class="form-control"
                           name="password"
                           v-model="newPasssword" />
                    <ErrorMessage name="password"
                                  class="error-feedback" />
                   
                  </div>
                  <div class="form-group">
                     <label for="email-for-pass">Confirm password</label>
                    <Field type="password"
                           class="form-control"
                           name="confirmPassword"
                           v-model="confirmPassword" />
                    <ErrorMessage name="confirmPassword"
                                  class="error-feedback" />
                    <small class="form-text text-muted">Enter your new password and confirm password</small>
                  </div>
                </Form>
                  <div class="form-group">
                    <button type="submit"
                            class="btn btn-primary"
                            @click="handleReset()">Submit</button>
                  </div>
          <div v-if="message"
               class="alert"
               :class="successful ? 'alert-success' : 'alert-danger'">
            <li v-for="(value, key) in message"
                :value="key"
                :key="key">{{ value.toString() }}</li>
          </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service'
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'

export default {
  name: 'FogotPassword',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      password: yup
        .string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters'),
      confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    })

    return {
      message: '',
      messageSucess: '',
      resetEmail: '',
      schema,
      newPasssword: '',
      confirmPassword: '',
    }
  },

  methods: {

    // clickLogin: function (event) {
    //   alert(this.messageSucess )
    //   if (event) {
    //     this.$router.push('/login');
    //   }
    // },

    handleReset() {
      UserService.resetPassword(
        this.newPasssword,
        this.confirmPassword,
        this.$route.params.uid,
        this.$route.params.resetToken
      ).then(
        (response) => {
        if (response.status == '200') {
          this.messageSucess = response.data.detail
          alert(this.messageSucess )
          this.$router.push('/login');
        }
      },

        (error) => {
          this.message = error.response.data
        }
      
      )
    },
  },
}
</script>


<style scoped>
body {
  background-color: #f9f9fa;
}

.flex {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

@media (max-width: 991.98px) {
  .padding {
    padding: 1.5rem;
  }
}

@media (max-width: 767.98px) {
  .padding {
    padding: 1rem;
  }
}

.padding {
  padding: 5rem;
}

.card {
  background: #fff;
  border-width: 0;
  border-radius: 0.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}

.card-header {
  background-color: transparent;
  border-color: rgba(160, 175, 185, 0.15);
  background-clip: padding-box;
}

.card-body p:last-child {
  margin-bottom: 0;
}

.card-hide-body .card-body {
  display: none;
}

.form-check-input.is-invalid ~ .form-check-label,
.was-validated .form-check-input:invalid ~ .form-check-label {
  color: #f54394;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #76b7e9;
  outline: 0;
  box-shadow: 0 0 0 0px #28a745;
}

.error-feedback {
  color: red;
}
</style>